import sortDirection from '@enums/sort-direction';

export function sortByDate(a, b, order) {
    if (order === sortDirection.ascending) {
        return new Date(a.lastUpdatedOn) - new Date(b.lastUpdatedOn);
    }

    return new Date(b.lastUpdatedOn) - new Date(a.lastUpdatedOn);
}

/**
 * Comparator for natural alphanumeric sort order.
 * Sorts numeric strings numerically ("2" before "10") and text alphabetically (case-insensitive).
 */
export function naturalSort(a, b) {
    return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
}
